import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "imageCheckbox", "bulkActionBtn", "publishBtn", "scheduleBtn", "channelSelect"]

  connect() {
    this.updateButtonState()
  }

  toggleSelectAll(event) {
    const checked = event.target.checked
    this.imageCheckboxTargets.forEach(cb => cb.checked = checked)
    this.selectAllTargets.forEach(sa => sa.checked = checked)
    this.updateButtonState()
  }

  checkboxChanged() {
    this.updateButtonState()
  }

  channelChanged() {
    this.updateButtonState()
  }

  reset() {
    this.selectAllTargets.forEach(sa => sa.checked = false)
    this.imageCheckboxTargets.forEach(cb => cb.checked = false)
    this.updateButtonState()
  }

  updateButtonState() {
    const checkedBoxes = this.imageCheckboxTargets.filter(cb => cb.checked)
    const hasSelection = checkedBoxes.length > 0
    const channelSelect = this.hasChannelSelectTarget ? this.channelSelectTarget : null
    const hasChannel = channelSelect && channelSelect.value !== ''

    if (this.hasBulkActionBtnTarget) {
      const btn = this.bulkActionBtnTarget
      if (hasChannel) {
        btn.disabled = true
        btn.classList.remove('bg-green-600', 'hover:bg-green-700')
        btn.classList.add('bg-gray-500', 'hover:bg-gray-600')
      } else if (hasSelection) {
        btn.disabled = false
        btn.classList.remove('bg-gray-500', 'hover:bg-gray-600')
        btn.classList.add('bg-green-600', 'hover:bg-green-700')
      } else {
        btn.disabled = true
        btn.classList.remove('bg-green-600', 'hover:bg-green-700')
        btn.classList.add('bg-gray-500', 'hover:bg-gray-600')
      }
    }

    if (this.hasPublishBtnTarget && channelSelect) {
      const publishBtn = this.publishBtnTarget
      if (hasSelection && hasChannel) {
        publishBtn.disabled = false
        publishBtn.classList.remove('bg-gray-500', 'hover:bg-gray-600')
        publishBtn.classList.add('bg-green-600', 'hover:bg-green-700')
      } else {
        publishBtn.disabled = true
        publishBtn.classList.remove('bg-green-600', 'hover:bg-green-700')
        publishBtn.classList.add('bg-gray-500', 'hover:bg-gray-600')
      }
    }

    if (this.hasScheduleBtnTarget && channelSelect) {
      const scheduleBtn = this.scheduleBtnTarget
      if (hasSelection && hasChannel) {
        scheduleBtn.disabled = false
        scheduleBtn.classList.remove('bg-gray-500', 'hover:bg-gray-600')
        scheduleBtn.classList.add('bg-blue-500', 'hover:bg-blue-600')
      } else {
        scheduleBtn.disabled = true
        scheduleBtn.classList.remove('bg-blue-500', 'hover:bg-blue-600')
        scheduleBtn.classList.add('bg-gray-500', 'hover:bg-gray-600')
      }
    }
  }
}
